var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4D4D4D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.875 7.875C17.496 7.875 18 8.379 18 9c0 .577-.434 1.052-.994 1.117l-.131.008H1.125C.504 10.125 0 9.621 0 9c0-.577.434-1.052.994-1.117l.131-.008h15.75z",
    transform: "translate(-1203 -269) translate(1204 269)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusGray);
export default __webpack_public_path__ + "static/media/minus-gray.1e7e90e8956e7c17df2ec98b5ae6ed1d.svg";
export { ForwardRef as ReactComponent };